<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    input(e) {
      this.$emit('input', e.target.value);
    },
    change(e) {
      this.$emit('change', e.target.value);
    },
    submit() {
      this.$refs.input.blur();
      this.$emit('submit');
    },
  },
};
</script>
<template>
  <input
    ref="input"
    :type="type"
    class="f-c-input"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="input"
    @change="change"
    @keypress.enter="submit"
  >
</template>
